<main class="contact-page">
  <section class="contact-hero" [attr.aria-label]="brandAlt">
    <div class="contact-hero__lang">
      <button type="button" class="contact-lang-btn" [class.active]="isLanguageMenuOpen" (click)="toggleLanguageMenu()">
        <img [src]="selectedLanguage.flag" [alt]="selectedLanguage.alt" class="contact-lang-btn__flag" />
        <span class="contact-lang-btn__code">{{ selectedLanguage.name }}</span>
        <span class="contact-lang-btn__chevron">▾</span>
      </button>

      <div class="contact-lang-dropdown" [class.open]="isLanguageMenuOpen">
        @for (lang of languages; track lang.code) {
          <button type="button" class="contact-lang-option" [class.active]="selectedLanguage.code === lang.code" (click)="selectLanguage(lang.code)">
            <img [src]="lang.flag" [alt]="lang.alt" class="contact-lang-btn__flag" />
            <span class="contact-lang-option__code">{{ lang.name }}</span>
          </button>
        }
      </div>
    </div>

    <picture>
      <source
        media="(max-width: 767.98px)"
        srcset="assets/websummit/banner-claro-empresas-mobile.png"
        width="828"
        height="1042"
      />
      <img
        class="contact-hero__banner"
        src="assets/websummit/banner-claro-empresas.png"
        [attr.alt]="brandAlt"
        width="2880"
        height="750"
        decoding="async"
        fetchpriority="high"
      />
    </picture>
  </section>

  <section id="contato" class="contact-lead" aria-labelledby="contact-heading">
    <div class="contact-lead__wrap">
      <div class="contact-card">
        <h1 id="contact-heading" class="contact-card__title">{{ title }}</h1>
        <form
          class="contact-card__form"
          [formGroup]="form"
          (ngSubmit)="onSubmit()"
          novalidate
          [hidden]="showSuccess"
        >
          <div class="contact-card__row contact-card__row--two">
            <label class="contact-field">
              <span class="contact-field__label">{{ nameLabel }} <span class="contact-field__req">*</span></span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('nome')"
                type="text"
                formControlName="nome"
                autocomplete="name"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('nome')">
                {{ showError('nome') ? errorMessage('nome') : '' }}
              </span>
            </label>

            <label class="contact-field">
              <span class="contact-field__label">{{ phoneLabel }} <span class="contact-field__req">*</span></span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('telefone')"
                type="tel"
                formControlName="telefone"
                inputmode="numeric"
                autocomplete="tel"
                placeholder="(__) _____-____"
                (input)="onPhoneInput($event, 'telefone')"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('telefone')">
                {{ showError('telefone') ? errorMessage('telefone') : '' }}
              </span>
            </label>
          </div>

          <div class="contact-card__row contact-card__row--two">
            <label class="contact-field">
              <span class="contact-field__label">{{ phone2Label }}</span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('telefone2')"
                type="tel"
                formControlName="telefone2"
                inputmode="numeric"
                autocomplete="tel"
                placeholder="(__) _____-____"
                (input)="onPhoneInput($event, 'telefone2')"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('telefone2')">
                {{ showError('telefone2') ? errorMessage('telefone2') : '' }}
              </span>
            </label>

            <label class="contact-field">
              <span class="contact-field__label">{{ emailLabel }}</span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('email')"
                type="email"
                formControlName="email"
                autocomplete="email"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('email')">
                {{ showError('email') ? errorMessage('email') : '' }}
              </span>
            </label>
          </div>

          <div class="contact-card__row contact-card__row--two">
            <label class="contact-field">
              <span class="contact-field__label">{{ cnpjLabel }} <span class="contact-field__req">*</span></span>
              <input
                class="contact-field__input"
                [class.contact-field__input--invalid]="showError('cnpj')"
                type="text"
                formControlName="cnpj"
                inputmode="numeric"
                autocomplete="off"
                placeholder="__.___.___/____-__"
                (input)="onCnpjInput($event)"
              />
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('cnpj')">
                {{ showError('cnpj') ? errorMessage('cnpj') : '' }}
              </span>
            </label>

            <label class="contact-field">
              <span class="contact-field__label">{{ stateLabel }} <span class="contact-field__req">*</span></span>
              <select
                class="contact-field__input contact-field__select"
                [class.contact-field__input--invalid]="showError('estado')"
                formControlName="estado"
              >
                <option value="">{{ selectLabel }}</option>
                @for (state of states; track state.value) {
                  <option [value]="state.value">{{ state.label }}</option>
                }
              </select>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('estado')">
                {{ showError('estado') ? errorMessage('estado') : '' }}
              </span>
            </label>
          </div>

          <div class="contact-card__row contact-card__row--two">
            <label class="contact-field">
              <span class="contact-field__label">{{ cityLabel }} <span class="contact-field__req">*</span></span>
              <select
                class="contact-field__input contact-field__select"
                [class.contact-field__input--invalid]="showError('cidade')"
                formControlName="cidade"
              >
                <option value="">{{ selectLabel }}</option>
                @if (isLoadingCities && form.controls.estado.value) {
                  <option value="" disabled>{{ loadingCitiesLabel }}</option>
                }
                @for (city of cities; track city) {
                  <option [value]="city">{{ city }}</option>
                }
              </select>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('cidade')">
                {{ showError('cidade') ? errorMessage('cidade') : '' }}
              </span>
            </label>

            <fieldset class="contact-choice contact-choice--radio-grid">
              <legend class="contact-choice__legend">
                {{ businessOwnerQuestion }} <span class="contact-field__req">*</span>
              </legend>
              <div class="contact-choice__options">
                @for (option of yesNoOptions; track option.value) {
                  <label class="contact-choice__option">
                    <input type="radio" [value]="option.value" formControlName="empresario" />
                    <span>{{ option.label }}</span>
                  </label>
                }
              </div>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('empresario')">
                {{ showError('empresario') ? errorMessage('empresario') : '' }}
              </span>
            </fieldset>
          </div>

          @if (isYesChoice(form.controls.empresario.value)) {
            <div class="contact-card__row contact-card__row--full">
              <label class="contact-field">
                <span class="contact-field__label">{{ businessSegmentQuestion }} <span class="contact-field__req">*</span></span>
                <select
                  class="contact-field__input contact-field__select"
                  [class.contact-field__input--invalid]="showError('ramoAtividade')"
                  formControlName="ramoAtividade"
                >
                  <option value="">{{ selectLabel }}</option>
                  @for (segment of activitySegments; track segment.value) {
                    <option [value]="segment.value">{{ segment.label }}</option>
                  }
                </select>
                <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('ramoAtividade')">
                  {{ showError('ramoAtividade') ? errorMessage('ramoAtividade') : '' }}
                </span>
              </label>
            </div>
          }

          <div class="contact-card__row contact-card__row--two">
            <fieldset class="contact-choice contact-choice--radio-grid">
              <legend class="contact-choice__legend">
                {{ businessExperienceQuestion }} <span class="contact-field__req">*</span>
              </legend>
              <div class="contact-choice__options">
                @for (option of businessExperienceOptions; track option.value) {
                  <label class="contact-choice__option">
                    <input type="radio" [value]="option.value" formControlName="experienciaEmpresarial" />
                    <span>{{ option.label }}</span>
                  </label>
                }
              </div>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('experienciaEmpresarial')">
                {{ showError('experienciaEmpresarial') ? errorMessage('experienciaEmpresarial') : '' }}
              </span>
            </fieldset>

            <fieldset class="contact-choice contact-choice--radio-grid">
              <legend class="contact-choice__legend">
                {{ initialInvestmentQuestion }} <span class="contact-field__req">*</span>
              </legend>
              <div class="contact-choice__options">
                @for (option of yesNoOptions; track option.value) {
                  <label class="contact-choice__option">
                    <input type="radio" [value]="option.value" formControlName="investimentoInicial" />
                    <span>{{ option.label }}</span>
                  </label>
                }
              </div>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('investimentoInicial')">
                {{ showError('investimentoInicial') ? errorMessage('investimentoInicial') : '' }}
              </span>
            </fieldset>
          </div>

          @if (isYesChoice(form.controls.investimentoInicial.value)) {
            <div class="contact-card__row contact-card__row--full">
              <fieldset class="contact-choice contact-choice--radio-grid">
                <legend class="contact-choice__legend">
                  {{ investmentRangeQuestion }} <span class="contact-field__req">*</span>
                </legend>
                <div class="contact-choice__options">
                  @for (option of investmentRangeOptions; track option.value) {
                    <label class="contact-choice__option">
                      <input type="radio" [value]="option.value" formControlName="faixaInvestimento" />
                      <span>{{ option.label }}</span>
                    </label>
                  }
                </div>
                <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('faixaInvestimento')">
                  {{ showError('faixaInvestimento') ? errorMessage('faixaInvestimento') : '' }}
                </span>
              </fieldset>
            </div>
          }

          <div class="contact-card__row contact-card__row--two">
            <fieldset class="contact-choice contact-choice--radio-grid">
              <legend class="contact-choice__legend">
                {{ salesExperienceQuestion }} <span class="contact-field__req">*</span>
              </legend>
              <div class="contact-choice__options">
                @for (option of yesNoOptions; track option.value) {
                  <label class="contact-choice__option">
                    <input type="radio" [value]="option.value" formControlName="experienciaVendas" />
                    <span>{{ option.label }}</span>
                  </label>
                }
              </div>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('experienciaVendas')">
                {{ showError('experienciaVendas') ? errorMessage('experienciaVendas') : '' }}
              </span>
            </fieldset>

            <fieldset class="contact-choice contact-choice--radio-grid">
              <legend class="contact-choice__legend">
                {{ businessNetworkQuestion }} <span class="contact-field__req">*</span>
              </legend>
              <div class="contact-choice__options">
                @for (option of yesNoOptions; track option.value) {
                  <label class="contact-choice__option">
                    <input type="radio" [value]="option.value" formControlName="relacionamentoEmpresarios" />
                    <span>{{ option.label }}</span>
                  </label>
                }
              </div>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('relacionamentoEmpresarios')">
                {{ showError('relacionamentoEmpresarios') ? errorMessage('relacionamentoEmpresarios') : '' }}
              </span>
            </fieldset>
          </div>

          <div class="contact-card__row contact-card__row--two">
            <fieldset class="contact-choice contact-choice--radio-grid">
              <legend class="contact-choice__legend">
                {{ dedicationQuestion }} <span class="contact-field__req">*</span>
              </legend>
              <div class="contact-choice__options">
                @for (option of dedicationOptions; track option.value) {
                  <label class="contact-choice__option">
                    <input type="radio" [value]="option.value" formControlName="dedicacao" />
                    <span>{{ option.label }}</span>
                  </label>
                }
              </div>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('dedicacao')">
                {{ showError('dedicacao') ? errorMessage('dedicacao') : '' }}
              </span>
            </fieldset>

            <fieldset class="contact-choice contact-choice--radio-grid">
              <legend class="contact-choice__legend">
                {{ commercialStructureQuestion }} <span class="contact-field__req">*</span>
              </legend>
              <div class="contact-choice__options">
                @for (option of yesNoOptions; track option.value) {
                  <label class="contact-choice__option">
                    <input type="radio" [value]="option.value" formControlName="estruturaComercial" />
                    <span>{{ option.label }}</span>
                  </label>
                }
              </div>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('estruturaComercial')">
                {{ showError('estruturaComercial') ? errorMessage('estruturaComercial') : '' }}
              </span>
            </fieldset>
          </div>

          <div class="contact-card__row contact-card__row--full">
            <fieldset class="contact-choice">
              <legend class="contact-choice__legend">
                {{ motivationQuestion }} <span class="contact-field__req">*</span>
              </legend>
              <div class="contact-choice__options">
                @for (option of motivationOptions; track option.value) {
                  <label class="contact-choice__option">
                    <input type="radio" [value]="option.value" formControlName="motivacao" />
                    <span>{{ option.label }}</span>
                  </label>
                }
              </div>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('motivacao')">
                {{ showError('motivacao') ? errorMessage('motivacao') : '' }}
              </span>
            </fieldset>
          </div>

          <div class="contact-card__row contact-card__row--full">
            <label class="contact-field">
              <span class="contact-field__label">
                {{ successReasonQuestion }} <span class="contact-field__req">*</span>
              </span>
              <textarea
                class="contact-field__input contact-field__textarea"
                [class.contact-field__input--invalid]="showError('justificativa')"
                formControlName="justificativa"
                rows="5"
                maxlength="2000"
              ></textarea>
              <span class="contact-field__error" role="alert" [attr.aria-hidden]="!showError('justificativa')">
                {{ showError('justificativa') ? errorMessage('justificativa') : '' }}
              </span>
            </label>
          </div>

          <div class="contact-card__actions">
            <button
              type="submit"
              class="contact-btn contact-btn--primary"
              [disabled]="!canSubmit"
              [attr.aria-disabled]="!canSubmit"
              [attr.aria-busy]="isSubmitting"
            >
              {{ isSubmitting ? sendingLabel : submitLabel }}
            </button>
            <button
              type="button"
              class="contact-btn contact-btn--ghost"
              [disabled]="!canClear || isSubmitting"
              [attr.aria-disabled]="!canClear || isSubmitting"
              (click)="onClear()"
            >
              {{ clearLabel }}
            </button>
          </div>
        </form>

        @if (showSuccess) {
          <p class="contact-card__success" role="status">
            {{ successMessage }}
          </p>
        }
      </div>
    </div>
  </section>
</main>

<footer class="contact-site-footer" role="contentinfo">
  <div class="contact-site-footer__inner">
    <img
      class="contact-site-footer__logo"
      src="https://mondrian.claro.com.br/brands/horizontal/default/claro-empresas.svg"
      alt="Claro empresas"
      width="86"
      height="28"
    />
    <div class="contact-site-footer__copy">
      <span class="contact-site-footer__line">{{ copyrightText }}</span>
      <span class="contact-site-footer__line">{{ rightsReservedText }}</span>
    </div>
  </div>
</footer>
